import { render, staticRenderFns } from "./AdditionalMaterial.vue?vue&type=template&id=6f682a7a&"
import script from "./AdditionalMaterial.vue?vue&type=script&lang=js&"
export * from "./AdditionalMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports